import { ReactElement } from 'react';
import { FormattedMessage, formatTranslation } from 'intl';
import { IssueTranslationKeys, InspectionTranslationKeys, InspectionTemplateTranslationKeys } from 'intl/keys';
import { useIntl } from 'react-intl';
import { Box, Stack } from '@mui/material';
import { ButtonOutlined, SubheaderText } from 'components/general';
import { MemoPreviewField } from 'components/general/PreviewField';

export interface ChecklistTreeHeaderProps {
  issuesCount?: number;
  allExpanded: boolean;
  hasExpanded?: boolean;
  collapseWhenAnyExpanded?: boolean;
  onToggleExpandAll: () => void;
}

export function ChecklistTreeHeader({
  issuesCount,
  allExpanded,
  hasExpanded,
  collapseWhenAnyExpanded = false,
  onToggleExpandAll,
}: ChecklistTreeHeaderProps): ReactElement {
  const intl = useIntl();
  const shouldShowCollapseLabel = collapseWhenAnyExpanded
    ? Boolean(hasExpanded)
    : allExpanded;

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: 4,
      }}
    >
      <Stack direction='column' spacing={2} sx={{ flex: 1 }}>
        <SubheaderText sx={{ my: 2 }}>
          {formatTranslation(intl, InspectionTemplateTranslationKeys.headerChecklist)}
        </SubheaderText>
        {issuesCount !== undefined && (
          <MemoPreviewField
            label={formatTranslation(intl, InspectionTranslationKeys.relatedIssuesCount,)}
            value={issuesCount > 99 ? '99+' : issuesCount.toString()}
            dense={true}
          />
        )}
      </Stack>

      <ButtonOutlined onClick={onToggleExpandAll}>
        {shouldShowCollapseLabel ? (
          <FormattedMessage id={IssueTranslationKeys.previewHistoryCollapseAll} />
        ) : (
          <FormattedMessage id={IssueTranslationKeys.previewHistoryUncollapseAll} />
        )}
      </ButtonOutlined>
    </Box>
  );
}
